import React, { useEffect, useState } from "react";
import LoginForm from "../../loginPage/login/loginForm";
import Footer from "../footer";
import Intro from "../intro";
import "../login.css";
import {parseJwt } from "../../utilities/utils";
import { useLocation, useNavigate } from "react-router-dom";
import {
  useOtpsentMutation, 
  useLazyVerifyTokenQuery,
  usePasswordverificationMutation,
} from "../../../services/loginservices";
import { useDispatch } from "react-redux";
import { createAlert } from "../../../features/alert/alerts";
import { ALERT_TYPE_SUCCESS, LOGIN_USER_TYPE_SERVICE_VOTER,LOGIN_USER_TYPE_ECI_OFFICIAL, USERTYPE, BASE_URLS, PLATFORM_TYPE } from "../../../constants/constants";
import { ALERT_TYPE_ERROR } from "../../../constants/constants";
import { useGetCaptchaServiceQuery } from "../../../services/captchaService";
import axios from "axios";
import MembersDetails from "./members/memberDetails";
import { styles } from "./members/member";
import CustomModal from "../../../library/components/Modal/modal";
import SelectField from "../../../library/components/Select";
import Button from "../../../library/components/Button";
import { setCookie } from "../../utilities/cookieUtils";

function Login() {
  let navigate = useNavigate();
  const [passwordverify ] = usePasswordverificationMutation();
  const [otpsent,datap] = useOtpsentMutation();
  const location =useLocation()
  const [exceedError, setExceedError] = useState(false);
  // const[userType,setUserType]=useState(location?.state?.key ||"ECI Official")
  const [resetPassword, setresetPassword] = useState(false);
  const [Error, setError] = useState({});
  const [captchaId, setCaptchaId] = useState("");
  const [captchaImage, setCaptchaImage] = useState();
  const [captchaArg, setCaptchaArg] = useState(true);
  const [errorData, setErrorData] = useState("");
  const dispatch = useDispatch();
  const [loginObj, setLoginObj] = useState({
    userId: "",
    password: "",
    captcha: "",
  });
   const [verifytoken,datav] = useLazyVerifyTokenQuery();
   const [roless, setRoles] = useState();
   const [show,setShow] = useState(false)
   const [showmodal,setShowmodal] = useState(false)
 

    
    const handleChange = (key, event) => {
    setLoginObj({ ...loginObj, [key]: event });
  };
  //  const params = new URLSearchParams(window.location.search);
  //  const redirectUri = params.get("redirect_uri");

  //  if (redirectUri) {
  //   localStorage.setItem("redirect_uri", redirectUri);
  // }

  // if (redirectUri === "") {
  //   localStorage.clear()
  // }
  //  console.log(app)
  const onReject = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_ERROR,
        heading: "Reject",
      })
    );
  };

  const {
    data: captchaData,
    isLoading,
    isError,
    error,
  } = useGetCaptchaServiceQuery([captchaArg], {
    refetchOnMountOrArgChange: true,
  });

  useEffect(() => {
    if (captchaData) setCaptchaImage(captchaData);
  }, [captchaData]);

useEffect(()=>{


//       verifytoken().then((res)=>{
//         let userRoles = parseJwt(res?.data?.access_token).realm_access.roles;
//         localStorage.setItem("refreshToken", res.data?.refresh_token);
//         localStorage.setItem("expiry", res.data?.expires_in);
//         localStorage.setItem("refreshExpiry", res.data?.refresh_expires_in);
//         localStorage.setItem("access_token", res?.data?.access_token);
//         localStorage.setItem(
//           "rtkn_bnd",
//           res.data?.rtkn_bnd
//         );
//         localStorage.setItem(
//           "atkn_bnd",
//           res.data?.atkn_bnd
//         );
//          localStorage.setItem(
//                   "userrole",
//                   parseJwt(res?.data?.access_token).realm_access.roles[0]
//                 );
//                 localStorage.setItem(
//                   "roles",
//                   parseJwt(res?.data?.access_token).realm_access.roles
//                 );
  
  
//                 var roles = [{ value: "", label: "Select Role" }];
//                 var role = userRoles;
//                 for (let i = 0; i < userRoles.length; i++) {
//                   if (
//                     !(
//                       role[i].includes("default") ||
//                       role[i].includes("offline") ||
//                       role[i].includes("admn") ||
//                       role[i].includes("authorization")
//                     )
//                   )
//                     roles.push({ value: role[i], label: role[i] });
//                 }
//                 setRoles(roles);
  
//                 if (roles.length > 2) {
//                   // setShow(true);
//                   // // window.location.href = "/" + loginObj.role
//                 } else {
//                   var elseroles = [];
//                   for (let i = 0; i < userRoles.length; i++) {
//                     if (
//                       !(
//                         role[i].includes("default") ||
//                         role[i].includes("offline") ||
//                         role[i].includes("admn") ||
//                         role[i].includes("authorization")
//                       )
//                     )
//                       elseroles.push(role[i]);
//                   }
//                   localStorage.userrole = elseroles[0];
//                   if(['ro','roac','ropc','deo','ceo','ceoa','nodal','record','unit','cs','epbr','epba','eci'].includes(elseroles[0]?.toLowerCase())){
//                  navigate("/" + elseroles[0] + "/" + "dashboard");
//                     // window.location.href ="/" + elseroles[0] + "/" + "dashboard";
//                     }else{
//                       navigate("/" + elseroles[0] + "/" + "accessNotAllowed")
//                       // window.location.href ="/" + elseroles[0] + "/" + "accessNotAllowed";
//                     }
//                   // if (
//                   //   elseroles[0] === "nodal" ||
//                   //   elseroles[0] === "record" ||
//                   //   elseroles[0] === "unit"
//                   // ) {
          
//                   //   window.location.href =
//                   //     "/" + localStorage.userrole + "/" + "svp" + "/" + "profile";
//                   // } else {
//                   //   window.location.href ="/" + localStorage.userrole + "/" + "dashboard";
        
//                   //     // updateLogin(datap.data?.access_token).unwrap().then((res)=>{window.location.href ="/" + localStorage.userrole + "/" + "dashboard"; }).catch((err)=>{ window.location.href ="/" + localStorage.userrole + "/" + "dashboard";})
        
//                   // }
//       }
// }).catch((err)=>{
//   localStorage.clear()
// })



axios.get(
  `${BASE_URLS.LOGIN_BASE_URL}api/v1/authn-sso/validate-token`,
  {
    withCredentials:true,
    headers: {
      "Content-Type": "application/json",
          channelidobo: "SVP",
          "PLATFORM-TYPE":PLATFORM_TYPE
    },
  }
).then((res) => {

  let userRoles = parseJwt(res?.data?.access_token).realm_access.roles;
        localStorage.setItem("refreshToken", res.data?.refresh_token);
        localStorage.setItem("expiry", res.data?.expires_in);
        localStorage.setItem("refreshExpiry", res.data?.refresh_expires_in);
        localStorage.setItem("access_token", res?.data?.access_token);
        localStorage.setItem(
          "rtkn_bnd",
          res.data?.rtkn_bnd
        );
        localStorage.setItem(
          "atkn_bnd",
          res.data?.atkn_bnd
        );
                localStorage.setItem(
                  "roles",
                  parseJwt(res?.data?.access_token).realm_access.roles
                );
  
  
                var roles = [{ value: "", label: "Select Role" }];
                var role = userRoles;
                for (let i = 0; i < userRoles.length; i++) {
                  if (
                    !(
                      role[i].includes("default") ||
                      role[i].includes("offline") ||
                      role[i].includes("admn") ||
                      role[i].includes("authorization")
                    )
                  )
                    roles.push({ value: role[i], label: role[i] });
                }
                setRoles(roles);
  
                if (roles.length > 2) {
                  setShowmodal(true);
                  // // window.location.href = "/" + loginObj.role
                } else {
                  var elseroles = [];
                  for (let i = 0; i < userRoles.length; i++) {
                    if (
                      !(
                        role[i].includes("default") ||
                        role[i].includes("offline") ||
                        role[i].includes("admn") ||
                        role[i].includes("authorization")
                      )
                    )
                      elseroles.push(role[i]);
                  }
                  localStorage.userrole = elseroles[0];
                  if(['ro','roac','ropc','deo','ceo','ceoa','nodal','record','unit','cs','epbr','epba','eci'].includes(elseroles[0]?.toLowerCase())){
                    // setTimeout(() => {
                //  navigate("/" + localStorage.userrole + "/" + "dashboard");
                //  navigate("/" + elseroles[0]+"/"+"dashboard")
                      
                //     }, 500);
                    window.location.href ="/" + elseroles[0] + "/" + "dashboard";
                    }else{
                      // setTimeout(() => {
                      // // navigate("/" + localStorage.userrole + "/" + "accessNotAllowed")
                      // navigate("/" + elseroles[0]+"/"+"accessNotAllowed")
                        
                      // }, 500);
                      window.location.href ="/" + elseroles[0] + "/" + "accessNotAllowed";
                    }
                  // if (
                  //   elseroles[0] === "nodal" ||
                  //   elseroles[0] === "record" ||
                  //   elseroles[0] === "unit"
                  // ) {
          
                  //   window.location.href =
                  //     "/" + localStorage.userrole + "/" + "svp" + "/" + "profile";
                  // } else {
                  //   window.location.href ="/" + localStorage.userrole + "/" + "dashboard";
        
                  //     // updateLogin(datap.data?.access_token).unwrap().then((res)=>{window.location.href ="/" + localStorage.userrole + "/" + "dashboard"; }).catch((err)=>{ window.location.href ="/" + localStorage.userrole + "/" + "dashboard";})
        
                  // }
      }
}).catch(()=>{
 localStorage.clear()
setCookie("XUSRLGLK",'true')
  setShow(true)
});
      
    },[])

  // useEffect(()=>{
  //   if(datav.isSuccess){
  //     console.log(datav)
  //     console.log(datav?.data)
  //     console.log(datav?.data?.access_token)
  //     let userRoles = parseJwt(datav?.data?.access_token).realm_access.roles;
  //     localStorage.setItem("refreshToken", datav.data?.refresh_token);
  //     localStorage.setItem("expiry", datav.data?.expires_in);
  //     localStorage.setItem("refreshExpiry", datav.data?.refresh_expires_in);
  //     localStorage.setItem("access_token", datav?.data?.access_token);
  //     localStorage.setItem(
  //       "rtkn_bnd",
  //       datav.data?.rtkn_bnd
  //     );
  //     localStorage.setItem(
  //       "atkn_bnd",
  //       datav.data?.atkn_bnd
  //     );
  //      localStorage.setItem(
  //               "userrole",
  //               parseJwt(datav?.data?.access_token).realm_access.roles[0]
  //             );
  //             localStorage.setItem(
  //               "roles",
  //               parseJwt(datav?.data?.access_token).realm_access.roles
  //             );


  //             var roles = [{ value: "", label: "Select Role" }];
  //             var role = userRoles;
  //             for (let i = 0; i < userRoles.length; i++) {
  //               if (
  //                 !(
  //                   role[i].includes("default") ||
  //                   role[i].includes("offline") ||
  //                   role[i].includes("admn") ||
  //                   role[i].includes("authorization")
  //                 )
  //               )
  //                 roles.push({ value: role[i], label: role[i] });
  //             }
  //             setRoles(roles);

  //             if (roles.length > 2) {
  //               // setShow(true);
  //               // // window.location.href = "/" + loginObj.role
  //             } else {
  //               var elseroles = [];
  //               for (let i = 0; i < userRoles.length; i++) {
  //                 if (
  //                   !(
  //                     role[i].includes("default") ||
  //                     role[i].includes("offline") ||
  //                     role[i].includes("admn") ||
  //                     role[i].includes("authorization")
  //                   )
  //                 )
  //                   elseroles.push(role[i]);
  //               }
  //               localStorage.userrole = elseroles[0];
  //               if(['ro','roac','ropc','deo','ceo','ceoa','nodal','record','unit','cs','epbr','epba','eci'].includes(elseroles[0]?.toLowerCase())){
  //              navigate("/" + elseroles[0] + "/" + "dashboard");
  //                 // window.location.href ="/" + elseroles[0] + "/" + "dashboard";
  //                 }else{
  //                   navigate("/" + elseroles[0] + "/" + "accessNotAllowed")
  //                   // window.location.href ="/" + elseroles[0] + "/" + "accessNotAllowed";
  //                 }
  //               // if (
  //               //   elseroles[0] === "nodal" ||
  //               //   elseroles[0] === "record" ||
  //               //   elseroles[0] === "unit"
  //               // ) {
        
  //               //   window.location.href =
  //               //     "/" + localStorage.userrole + "/" + "svp" + "/" + "profile";
  //               // } else {
  //               //   window.location.href ="/" + localStorage.userrole + "/" + "dashboard";
      
  //               //     // updateLogin(datap.data?.access_token).unwrap().then((res)=>{window.location.href ="/" + localStorage.userrole + "/" + "dashboard"; }).catch((err)=>{ window.location.href ="/" + localStorage.userrole + "/" + "dashboard";})
      
  //               // }
  //             }}

  //             if(datav.isError){
  //               // localStorage.clear();
  //               // window.location.replace("https://demoecinet.eci.gov.in/logout?redirect_uri=ETPBMS");
  //               return
  //             }
  // },[datav])

  const handlesubmit = async (e, data) => {
    e.preventDefault();
    let error = {};
    // if (!loginObj.userType || loginObj.userType === "") {
    //   error["userType"] = "This field is required";
    // }
    if (!loginObj.userId || loginObj.userId === "") {
      error["userId"] = "This field is required";
    }
    // else if (loginObj.userId != "" && !(new RegExp(/^[\sA-Za-z\-\.,'/()&]{0,250}$/).test(loginObj.userId))){
    //   error["userId"] = "Please enter valid userId";
    // }
    // if (!loginObj.password || loginObj.password === "") {
    //   error["password"] = "This field is required";
    // } 
    if (Object.keys(error).length) {
      setError(error);
      return;
    }
  //   var data = {
  //     applicationName: "back_office",
  //     // password: "a",
  //     roleCode: "*",
  //     password: loginObj.password,
  //     // username: "9123456781"
  //     username: loginObj.userId.trim(),
  //   }

  //   var serviceVoterData={   
  //  username:loginObj.userId.trim(),
  //   password:loginObj.password,
  //   applicationName:"etpbs",
  //   roleCode: loginObj.userType
  // }

  //  if(loginObj.userType && (loginObj.userType=="cs"||loginObj.userType=="ro"||loginObj.userType=="nodl"||loginObj.userType=="recd"||loginObj.userType=="unit")){
  //   passwordverify(serviceVoterData);
  //  }else{
  //   passwordverify(data);
  //  }
  var eciData = {
    applicationName: USERTYPE.ERONET,
    roleCode: "*",
    username: loginObj.userId.trim(),
    captcha: captchaId,
    captchaId: captchaData?.id
  };
   otpsent(eciData);
  };

   useEffect(() => {
    if (datap.isSuccess) {
    dispatch(
      createAlert({
        message: "OTP sent Sucessfully.",
        type: ALERT_TYPE_SUCCESS,
        heading: "Sucess",
      })
    );
    navigate(`/otp`,{state: {userid:loginObj.userId},replace:true});
    }
   }, [datap.isSuccess]);

   useEffect(() => {
    if (datap.isError) {
      setCaptchaArg(!captchaArg);
      setCaptchaId("");
    }
  }, [datap.isError]);

  // useEffect(() => {

  //   if (datap.isError) {

  //     if (datap.error.data && datap.error.data.cause && datap.error.data.cause !== null) {
  //       if (datap.error.data && datap.error.data.cause && datap.error.data.cause.disabled === false) {
  //         onReject(
  //           `Incorrect Attempts : ` +
  //             datap.error.data.cause.numFailures +
  //             `. You will be locked after ${datap.error.data.cause.allowedIncorrectAttempts} Incorrect attempts`
  //         );
  //       } else {
  //         onReject(
  //           // "Incorrect Attempts : " +
  //           //   datap.error.data.cause.numFailures +
  //             `\n You are locked for ${datap.error.data.cause.waitTimeAfterLock / 60} minutes. `
  //         );
  //       }
  //     }

  //     // var data1 = {
  //     //   applicationName: "back_office",
  //     //   roleCode: "*",
  //     //   // username: "9123456781"
  //     //   username:loginObj.userId
  //     // }
  //     // otpsent(data1)
  //     // navigate(`/otp/${loginObj.userId}`);
  //   }
  // }, [datap.isError]);

  return (
    <>
       <CustomModal
                      modalTitle=""
                      children={
                        <div className="pl-3 pt-2">
                          <SelectField
                            label="Select Role"
                            required={true}
                            name="role"
                            options={roless}
                            // options={dropdownvaluefilter(formtypefilter,"value")}
                            labelClass="col-md-12 pr-0 pt-2 processing-label"
                            inputClass="col-md-12"
                            value={loginObj.role}
                            handleChange={(val) => handleChange("role", val)}
                          />
                        </div>
                      }
                      show={showmodal}
                      size="30%"
                      modalFooter={
                        <Button
                          btnClass="px-4 btn-blue mb-4 float-right"
                          value={<>Submit &nbsp;</>}
                          type="submit"
                          onClick={() => {
                            setShowmodal(false);
                            // setAuth((prev)=>({
                            //   ...prev,
                            //   userrole:loginObj.role

                            // )
                            localStorage.setItem("userrole",loginObj.role)
                    
                   window.location.href = "/" + loginObj.role  + "/" + "dashboard"; 

        
                      // updateLogin(datap.data?.access_token).unwrap().then((res)=>{window.location.href ="/" + localStorage.userrole + "/" + "dashboard"; }).catch((err)=>{ window.location.href ="/" + localStorage.userrole + "/" + "dashboard";})
        
                  
                            // updateLogin(datap.data?.access_token).unwrap().then((res)=>{window.location.href = "/" + loginObj.role  + "/" + "dashboard"; }).catch((err)=>{window.location.href = "/" + loginObj.role  + "/" + "dashboard"; })
    
                          }}
                        />
                      }
                    />
   {show &&
     <div style={styles.main}>
        <div style={styles.row}>

          {/* Left Div - Commissioners */}
          <MembersDetails></MembersDetails>
            <div style={styles.boxLogin}>
     
        <div className="form_login" >
          <form onSubmit={handlesubmit} className="form_align">
            <LoginForm
              loginObj={loginObj}
              setLoginObj={setLoginObj}
              setError={setError}
              Error={Error}
              exceedError={exceedError}
              resetPassword={resetPassword}
              tabSwitch={location}
              captchaId={captchaId}
              setCaptchaId={setCaptchaId}
              errorData={errorData}
              setErrorData={setErrorData}
              captchaData={captchaData}
              setCaptchaArg={setCaptchaArg}
              captchaArg={captchaArg}
            ></LoginForm>
          </form>
        </div>
      </div>
    </div>
  </div>
   }
    </>
  );
}

export default Login;
